// extracted by mini-css-extract-plugin
module.exports = {"cancel__text":"InvoicesReciept_cancel__text__2E2Gt","receipt__number":"InvoicesReciept_receipt__number__u96FF"};